module.exports = __webpack_public_path__ + "img/seller_invoices.9e757b00.svg";